export const getQueryParamObj = (key) => {
    try {
        const value = '';
        return value
            ? JSON.parse(atob(decodeURIComponent(decodeURIComponent(value))))
            : {};
    }
    catch (error) {
        console.warn(error);
        return {};
    }
};
export const getMenuEntity = async (menuId) => {
    if (!menuId) {
        return {};
    }
    if (true) {
        return Promise.resolve({ icon: '', menuName: '' });
    }
    const menuEntity = [];
    return menuEntity;
};
export const replaceDigitsUsingCustomFunction = (str) => {
    if (!str) {
        return;
    }
    if (str.includes('元')) {
        str;
    }
    return str;
};
export const handleSoutquestion = (soutquestion) => {
    if (!soutquestion)
        return;
    return soutquestion.replace(/\[\d+\]\s*|\[\]/g, '');
};
export function simpleUUID() {
    const timeStamp36 = Date.now().toString(36);
    const randomStr = 'xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    return `${timeStamp36}-${randomStr}`;
}
const seenUrls = new Set();
const loadSingleImage = (parentNode, url) => {
    return new Promise((resolve) => {
        if (seenUrls.has(url)) {
            resolve(true);
            return;
        }
        const img = document.createElement('img');
        img.src = url;
        img.className = 'wapb-ai-chat-hidden-img';
        img.onload = () => {
            parentNode.removeChild(img);
            resolve(true);
        };
        img.onerror = () => {
            parentNode.removeChild(img);
            resolve(false);
        };
        parentNode.appendChild(img);
        seenUrls.add(url);
    });
};
export async function loadImg(imgUrls) {
    const parentNode = document.querySelector('.wapb-chat-hidden-wrap');
    if (!parentNode) {
        console.warn('parentNode not found');
        return;
    }
    return await Promise.all(imgUrls.map((url) => loadSingleImage(parentNode, url)));
}
export function formatRelativeDate(timestamp) {
    if (!timestamp)
        return '';
    let _timestamp = typeof timestamp === 'string' ? Number(timestamp) : timestamp;
    const now = new Date();
    const date = new Date(_timestamp);
    if (date.toDateString() === now.toDateString()) {
        return `今天 ${formatTime(date)}`;
    }
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (date.toDateString() === yesterday.toDateString()) {
        return `昨天 ${formatTime(date)}`;
    }
    if (date.getFullYear() === now.getFullYear()) {
        return `${date.getMonth() + 1}月${date.getDate()}日 ${formatTime(date)}`;
    }
    else {
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${formatTime(date)}`;
    }
}
export function formatTime(date) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}
export const requestIdleCallback = typeof window !== 'undefined' && window.requestIdleCallback
    ? window.requestIdleCallback
    : (cb) => {
        const start = Date.now();
        return setTimeout(() => {
            cb({
                didTimeout: false,
                timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
            });
        }, 1);
    };
export function numberToChinese(num) {
    if (isNaN(num) || num < 0 || num > 60) {
        return num.toString();
    }
    const chineseNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const units = ['', '十'];
    if (num <= 10) {
        return num === 10 ? '十' : chineseNums[num];
    }
    const ten = Math.floor(num / 10);
    const digit = num % 10;
    let result = '';
    if (ten === 1) {
        result = '十';
    }
    else {
        result = chineseNums[ten] + '十';
    }
    if (digit !== 0) {
        result += chineseNums[digit];
    }
    return result;
}
export function readDateTime(dateTime) {
    const timeRegex = /(\d+)\s*[:： ]\s*(\d+)/;
    const timeMatch = dateTime.match(timeRegex);
    if (!timeMatch) {
        return dateTime;
    }
    const hours = parseInt(timeMatch[1], 10);
    const minute = parseInt(timeMatch[2], 10);
    const chineseTime = `${numberToChinese(hours)}点${numberToChinese(minute)}分`;
    return dateTime.replace(timeRegex, chineseTime);
}
export function stopTTS() {
}
